import React from "react"
import PropTypes from "prop-types"
import { Button } from "antd"
import { useTranslation } from "react-i18next"
import EventBlock from "../EventBlock"
import { getEventColor, getEventBorderColor } from "pagesV2/pro/Calendar/utils"
import styles from "../index.module.css"

const GridEventCell = ({ cellEvents, visibleCount, maxVisible, onShowMore, onShowLess, onBookingClick, cellKey, tdClassName, innerClassName }) => {
  const { t } = useTranslation()

  const visibleEvents = cellEvents.slice(0, visibleCount)
  const hasMore = cellEvents.length > visibleCount
  const canShowLess = !hasMore && cellEvents.length > maxVisible

  return (
    <td className={tdClassName}>
      <div className={innerClassName || styles.eventCellInner}>
        {visibleEvents.map((ev) => (
          <EventBlock
            key={ev.id ?? (ev.title + ev.start)}
            event={ev}
            eventColor={getEventColor(ev.payment_status)}
            eventBorderColor={getEventBorderColor(ev.payment_status)}
            setIsBookingModalOpen={(open) => { if (open) onBookingClick(ev.id) }}
            setSelectedBookingId={() => {}}
            compact
          />
        ))}
        {hasMore && (
          <Button type="link" size="small" onClick={() => onShowMore(cellKey)}>
            {t("calendar.view_more")}
          </Button>
        )}
        {canShowLess && (
          <Button type="link" size="small" onClick={() => onShowLess(cellKey)}>
            {t("calendar.view_less")}
          </Button>
        )}
      </div>
    </td>
  )
}

GridEventCell.propTypes = {
  cellEvents: PropTypes.array.isRequired,
  visibleCount: PropTypes.number.isRequired,
  maxVisible: PropTypes.number.isRequired,
  onShowMore: PropTypes.func.isRequired,
  onShowLess: PropTypes.func.isRequired,
  onBookingClick: PropTypes.func.isRequired,
  cellKey: PropTypes.string.isRequired,
  tdClassName: PropTypes.string,
  innerClassName: PropTypes.string,
}

export default GridEventCell
